import PropTypes from 'prop-types';
import { noop } from '../../../../utils/noop';
import { useImageGalleryControlButtons } from './hooks/useImageGalleryControlButtons';
import { ImageGalleryControlButtonsStyles } from './ImageGalleryControlButtons.style';

const ImageGalleryControlButtons = ({ onPreviousHeadLine, onNextHeadline, onMoveOver, variant, isConnect }) => {
  const hookData = useImageGalleryControlButtons({
    onPreviousHeadLine,
    onNextHeadline,
    onMoveOver,
    variant,
    isConnect,
  });

  if (!hookData.shouldRender) {
    return null;
  }

  const { leftButtonConfig, rightButtonConfig } = hookData;

  return (
    <>
      <button
        id={leftButtonConfig.id}
        type="button"
        className={leftButtonConfig.className}
        onClick={leftButtonConfig.onClick}
        onMouseMove={leftButtonConfig.onMouseMove}
      >
        <i className={leftButtonConfig.iconClass} />
      </button>

      <button
        id={rightButtonConfig.id}
        type="button"
        className={rightButtonConfig.className}
        onClick={rightButtonConfig.onClick}
        onMouseMove={rightButtonConfig.onMouseMove}
      >
        <i className={rightButtonConfig.iconClass} />
      </button>
      <style jsx>{ImageGalleryControlButtonsStyles}</style>
    </>
  );
};

ImageGalleryControlButtons.defaultProps = {
  onMoveOver: noop,
  variant: 'transparent',
  isConnect: false,
};

ImageGalleryControlButtons.propTypes = {
  onPreviousHeadLine: PropTypes.func.isRequired,
  onNextHeadline: PropTypes.func.isRequired,
  onMoveOver: PropTypes.func,
  variant: PropTypes.oneOf(['opaque', 'transparent', 'smallAndTransparent']),
  isConnect: PropTypes.bool,
};

export { ImageGalleryControlButtons };
export default ImageGalleryControlButtons;
